import React from 'react';
import {
  Box,
  Button,
  Typography,
  useTheme,
  Container
} from '@mui/material';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { 
  Calculate, 
  PlayArrow,
  Description
} from '@mui/icons-material';

export default function HomePage() {
  const theme = useTheme();


  return (
    <Layout>
      <Container maxWidth="lg">
        {/* Hero Section */}
        <Box sx={{ py: 4, textAlign: 'center' }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
              fontFamily: '"Comic Neue", "Comic Sans MS", cursive',
              fontWeight: 900,
              color: theme.palette.mode === 'dark' ? '#ffffff' : 'text.primary',
              mb: 2,
            }}
          >
            Stop Wasting Money on Meetings & Documents
          </Typography>
          
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              color: 'text.secondary',
              fontFamily: '"Comic Neue", "Comic Sans MS", cursive',
              fontWeight: 500,
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.3,
            }}
          >
            Discover the true cost of your meetings and documents and make smarter decisions about your team's time
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', mb: 3 }}>
            <Button
              component={Link}
              to="/meetings"
              variant="contained"
              size="large"
              startIcon={<Calculate />}
              sx={{
                px: 4,
                py: 2,
                fontSize: '1.1rem',
                fontFamily: '"Comic Neue", "Comic Sans MS", cursive',
                fontWeight: 700,
                borderRadius: 3,
                background: 'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  background: 'linear-gradient(45deg, #1565c0 30%, #1976d2 90%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
                },
              }}
            >
              Calculate Meeting Cost
            </Button>
            
            <Button
              component={Link}
              to="/live-meetings"
              variant="contained"
              size="large"
              startIcon={<PlayArrow />}
              sx={{
                px: 4,
                py: 2,
                fontSize: '1.1rem',
                fontFamily: '"Comic Neue", "Comic Sans MS", cursive',
                fontWeight: 700,
                borderRadius: 3,
                background: 'linear-gradient(45deg, #51cf66 30%, #69db7c 90%)',
                boxShadow: '0 4px 12px rgba(81, 207, 102, 0.3)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  background: 'linear-gradient(45deg, #40c057 30%, #51cf66 90%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 16px rgba(81, 207, 102, 0.4)',
                },
              }}
            >
              Start Live Timer
            </Button>
            
            <Button
              component={Link}
              to="/documents"
              variant="contained"
              size="large"
              startIcon={<Description />}
              sx={{
                px: 4,
                py: 2,
                fontSize: '1.1rem',
                fontFamily: '"Comic Neue", "Comic Sans MS", cursive',
                fontWeight: 700,
                borderRadius: 3,
                background: 'linear-gradient(45deg, #ff6b6b 30%, #ff8a80 90%)',
                boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  background: 'linear-gradient(45deg, #ff5252 30%, #ff6b6b 90%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 16px rgba(255, 107, 107, 0.4)',
                },
              }}
            >
              Calculate Document Cost
            </Button>
          </Box>

        </Box>


      </Container>
    </Layout>
  );
}